<template>
  <div class="trail-show-params">
    <div v-for="(param, index) in trailParams" :key="index" class="item">
      <div class="label">{{ param.label }}</div>
      <div class="value">{{ param.value }}</div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'TrailShowParams',

  /**
   * 属性
   */
  props: {
    trail: Object,
    params: Array,
  },

  /**
   * 数据
   */
  data() {
    return {};
  },

  /**
   * 计算属性
   */
  computed: {
    trailParams() {
      let params = [
        {
          label: '行程',
          value: `${this.trail.seriesCount}段`,
        },
        {
          label: '集数',
          value: `${this.trail.packCount}集`,
        },
        {
          label: '节数',
          value: `${this.trail.nodeCount}节`,
        },
        {
          label: '全长',
          value: this.trail.duration,
        },
      ];

      if (this.params) {
        params = this.params.map(param => {
          return params.find(item => item.label === param);
        });
      }

      return params;
    },
  },

  /**
   * 已创建
   */
  created() {
    //
  },

  /**
   * 组件方法
   */
  methods: {},

  /**
   * 使用组件
   */
  components: {},
});
</script>

<style scoped>
@import './styles/trail-show-params.css';
</style>
